<template>
  <div class="page-con">
    <div
        class="finance-header"
        style="display: flex; flex-wrap: wrap; padding-bottom: 10px"
    >
      <span class="finance-span finance-span-time">
          <label style="margin-right: 10px">时间</label>
          <DatePicker
              v-model="startTime"
              type="date"
              placeholder="选择日期"
              style="width: 120px"
          ></DatePicker>
          <i class="line-icon">--</i>
          <DatePicker
              v-model="endTime"
              type="date"
              placeholder="选择日期"
              style="width: 120px"
          ></DatePicker>
      </span>
      <span class="finance-span">
          <label>所属公司</label>
          <Select
              class="searchSelect"
              v-model="searchCompName"
              multiple
              filterable
              prefix="ios-arrow-down"
              :remote-method="
              file =>
                remoteMethod(
                  file,
                  'compNameOptions',
                  'twoReport',
                  'saleManAmountCompanyName'
                )
            "
              :default-label="[]"
              :loading="searchLoading"
              :max-tag-count="1"
              :max-tag-placeholder="maxTagPlaceholder"
              @on-set-default-options="
              file => setDefaultOptions(file, 'compNameOptions')
            "
              placeholder="输入所属公司"
          >
            <Option
                v-for="option in compNameOptions"
                :value="option.paramValue"
                :key="option.paramValue"
            >{{ option.paramValue }}</Option
            >
          </Select>
        </span>
      <span class="finance-span">
          <label>业务员</label>
          <Select
              class="searchSelect"
              v-model="searchSalesMan"
              multiple
              filterable
              prefix="ios-arrow-down"
              :remote-method="
              file =>
                remoteMethod(
                  file,
                  'salesManOptions',
                  'twoReport',
                  'saleManAmountSalesMan'
                )
            "
              :default-label="[]"
              :loading="searchLoading"
              :max-tag-count="1"
              :max-tag-placeholder="maxTagPlaceholder"
              @on-set-default-options="
              file => setDefaultOptions(file, 'salesManOptions')
            "
              placeholder="输入业务员"
          >
            <Option
                v-for="option in salesManOptions"
                :value="option.paramValue"
                :key="option.paramValue"
            >{{ option.paramValue }}</Option
            >
          </Select>
        </span>
      <span class="finance-span">
          <label>流程类型</label>
          <vxe-select
              multiple
              clearable
              v-model="sourceType"
              :options="flowOptions"
              placeholder="请选择流程类型"
              style="width: 200px;"
          ></vxe-select>
        </span>
      <span class="finance-span" style="margin-left: auto">
          <Button
              type="primary"
              icon="ios-search"
              @click="getSearchListKey"
              style="border-radius: 5px;margin-right: 10px">搜索</Button>
              <vxe-button
                  icon="vxe-icon--download"
                  @click="exportData"
                  v-if="isHavePermission('franchiseeBalance:export')"
              >导出</vxe-button>
         <vxe-button icon="vxe-icon--refresh" @click="getListData">刷新</vxe-button>
        </span>
    </div>
    <div class="list-box common-shadow">
      <vxe-table
          ref="xTable"
          class="table-style"
          stripe
          import-config
          export-config
          highlight-hover-row
          show-overflow
          show-footer
          max-height="650"
          border="none"
          align="center"
          :loading="loading"
          :footer-cell-class-name="footerCellClassName"
          :footer-method="footerMethod"
          :data="tableData"
          resizable
      >
        <vxe-table-column type="seq" title="序号" align="center" width="120"></vxe-table-column>
        <vxe-table-column field="salesMan" title="业务员" min-width="140"></vxe-table-column>
        <vxe-table-column field="invoiceAmount" title="发票金额" min-width="140"></vxe-table-column>
        <vxe-table-column field="initBalance" title="期初余额" min-width="140"></vxe-table-column>
        <vxe-table-column field="debitAmount" title="借方" min-width="140"></vxe-table-column>
        <vxe-table-column field="creditAmount" title="贷方" min-width="140"></vxe-table-column>
        <vxe-table-column field="allBalance" title="期末余额" min-width="140"></vxe-table-column>
      </vxe-table>
    </div>
  </div>
</template>
<script>
import {numberToCurrency, numberToMoney} from "@/filters/type";
import {getBlob, hideLoading, isEmpty, saveBlob, showLoading} from "@/utils/util";
import $api from "@/apiProvider";
import getAuthOrization from "@/mixin/getAuthOrization";
import XEUtils from "xe-utils";
import moment from "moment";

const empties = [undefined, "", null, "null", {}, []];

export default {
  mixins: [getAuthOrization],
  data() {
    return {
      loading: false,
      tableData: [],
      startTime: "",
      endTime: "",
      searchSalesMan: [],
      searchCompName: [],
      salesManOptions: [],
      compNameOptions: [],
      searchLoading: false,
      flowOptions: [
        {
          label: "全部",
          value: -1
        },
        {
          label: "费用支出流程",
          value: 3
        },
        {
          label: "款项收入流程",
          value: 2
        },
        {
          label: "开票申请流程",
          value: 4
        },
        {
          label: "抵扣票申请流程",
          value: 5
        },
        {
          label: "加盟商往来款",
          value: 6
        }
      ],
      sourceType: null,
      searchParams: {},
    }
  },
  mounted() {
    this.reset();
    this.startTime = moment().startOf("month").format("YYYY-MM-DD");
    this.endTime = moment().endOf("day").format("YYYY-MM-DD");
    this.getList('', 'compNameOptions', 'twoReport', 'saleManAmountCompanyName');
  },
  methods: {
    getSearchListKey() {
      if (
          this.startTime === "" &&
          this.endTime === "" &&
          this.searchSalesMan.length === 0 &&
          this.searchCompName.length === 0 &&
          !this.sourceType
      ) {
        this.$XModal.alert({
          message: "请输入搜索条件",
          status: "error"
        });
        return;
      }
      let searchParams = {};
      searchParams.salesMan = this.searchSalesMan;
      searchParams.compName = this.searchCompName;
      if (this.sourceType && this.sourceType.length > 0) {
        searchParams.sourceTypes = this.sourceType
      }
      if (this.source && this.source !== -1) {
        searchParams.source = this.source
      }
      this.searchParams = searchParams;
      this.getListData();
    },
    reset() {
      this.startTime = "";
      this.endTime = "";
      this.searchSalesMan = [];
      this.searchCompName = [];
      this.tableData = [];
      this.sourceType = null;
    },
    async exportData() {
      let a = this.searchParams;
      if (isEmpty(this.tableData)) {
        this.$XModal.message("先搜索数据");
        return;
      }
      showLoading();
      let res = getBlob(
          "/api/order/twoReport/exportSaleManAmountTotal",
          this.searchParams
      );
      hideLoading();
      await saveBlob("导出加盟商款余额汇总.xls", res.data);
    },
    async getListData() {
      this.tableData = [];
      this.queryAction = "saleManAmountTotal";
      this.loading = true;
      this.searchParams.beginDate =
          this.startTime === ""
              ? this.startTime
              : this.$utils.timestamp(this.startTime);
      this.searchParams.endDate =
          this.endTime === ""
              ? this.endTime
              : this.$utils.timestamp(this.endTime) + 86399000;
      let params = empties.includes(this.searchParams) ? {} : this.searchParams;
      let res = await $api.twoReport.request(this.queryAction, params);
      if (res.status === 1) {
        this.tableData = res.data;
        this.loading = false;
      } else {
        if (empties.includes(res.message)) res.message = "接口异常";
        this.$XModal.message(res.message);
      }
    },
    footerCellClassName({$rowIndex, column, columnIndex}) {
      return "footer-cell";
    },
    footerMethod({columns, data}) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "全部合计";
          }
          if (["initBalance"].includes(column.property)) {
            return numberToMoney(XEUtils.sum(data, column.property));
          }

          if (["invoiceAmount"].includes(column.property)) {
            return numberToMoney(XEUtils.sum(data, column.property));
          }
          if (["allBalance"].includes(column.property)) {
            return numberToMoney(XEUtils.sum(data, column.property));
          }
          if (["debitAmount"].includes(column.property)) {
            return numberToMoney(XEUtils.sum(data, column.property));
          }
          if (["creditAmount"].includes(column.property)) {
            return numberToMoney(XEUtils.sum(data, column.property));
          }
          return null;
        }),
      ];
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    remoteMethod(query, options, url, path) {
      if (query !== "") {
        this.searchLoading = true;
        this.getList(query, options, url, path);
      } else {
        this[options] = [];
      }
    },
    async getList(query, options, url, path) {
      let params = {};

      if (!isEmpty(query)) {
        params.param = query;
      }
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].get(path, params);
      this.searchLoading = false;
      if (res.status === 1) {
        let data = res.data;
        this[options] = [];
        data.map((i, index) => {
          if (index < 10) {
            this[options].push(i);
          }
        });
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
  },
}
</script>
<style>
.searchSelect >>> .ivu-tag-text {
  max-width: 60px;
}
</style>